import { Libraries } from '@react-google-maps/api';

export const CONFIG = {
  GOOGLE_PLACES_LIBRARIES: ['places', 'geometry'] as Libraries,
  GOOGLE_MAPS_DEBOUNCE: 300,
  GOOGLE_MAPS_COUNTRY: 'in',
};
